import { useState } from 'react';
import { FormGroup } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import { settingLengthLimits } from '../../../../../shared/settings/portal';
import isSlug from '../../../../../shared/utils/isSlug';
import validSlugPattern from '../../../../../shared/utils/validSlugPattern';
import LabeledTextArea from '../../../generic/Forms/LabeledTextArea';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';
import Text from '../../../generic/Text';
import Toggle from '../../../generic/Toggle';
import LogoUpload from '../../../LogoUpload';
import type { PortalSettings } from '../../../../../shared/settings/portal';

import styles from './SettingsOrganizationPortal.module.less';

type Props = {
  settings: PortalSettings | null;
  onUpdateSettings: (settings: Partial<PortalSettings>) => void;
  fileUrl: string;
  setFile: (file: File) => void;
  unsetFile: () => void;
  handleImgError: () => void;
};

const Configuration: VoidFunctionComponent<Props> = ({
  settings,
  onUpdateSettings,
  fileUrl,
  setFile,
  unsetFile,
  handleImgError,
}) => {
  const [isUserSlug, setIsUserSlug] = useState(false);

  return (
    <>
      <Text.H3>Configuration</Text.H3>
      <FormGroup className={styles.toggleContainerFormGroup}>
        <Toggle
          checked={settings?.isEnabled}
          onChange={(value) => {
            onUpdateSettings({
              isEnabled: value,
            });
          }}
          icons={false}
        />

        <Text.Text>
          {settings?.isEnabled ? 'Portal Enabled' : 'Portal Disabled'}
        </Text.Text>

      </FormGroup>

      <FormGroup className={styles.textInputFormGroup}>
        <LabeledTextInput
          labelVariant="legacy"
          maxLength={settingLengthLimits.title}
          isRequired
          showCharCount
          label="Portal Name"
          value={settings?.title || ''}
          placeholder="Portal Name"
          onChange={(title) => {
            onUpdateSettings({
              title,
            });
          }}
        />
      </FormGroup>
      <FormGroup>
        <LabeledTextArea
          labelVariant="legacy"
          maxLength={settingLengthLimits.description}
          isRequired
          showCharCount
          label="Description"
          value={settings?.description || ''}
          placeholder="Description"
          onChange={(description) => {
            onUpdateSettings({
              description,
            });
          }}
        />
      </FormGroup>
      <FormGroup className={styles.textInputFormGroup}>
        <LabeledTextInput
          labelVariant="legacy"
          maxLength={settingLengthLimits.slug}
          isRequired
          showCharCount
          label="URL slug"
          value={settings?.slug || ''}
          placeholder="URL slug"
          onChange={(slug) => {
            setIsUserSlug(true);
            onUpdateSettings({
              slug,
            });
          }}
          pattern={validSlugPattern}
        />
        {
          !isSlug(settings?.slug || '') && isUserSlug ?
            <div className={styles.recommendationText}>
              You may customize part of the URL to access our portal.
              <b className={styles.slugRequirementsEmphasis}>
                Slashes and special characters are not allowed.
                Only letters, numbers, and dashes are allowed. Limited to 48 characters
              </b>
            </div> :
            <div className={styles.recommendationText}>
              You may customize part of the URL to access our portal.
              Slashes and special characters are not allowed.
              Only letters, numbers, and dashes are allowed. Limited to 48 characters
            </div>
        }
      </FormGroup>
      <Text.H3>Logo</Text.H3>
      <LogoUpload fileUrl={fileUrl} setFile={setFile} unsetFile={unsetFile} handleImgError={handleImgError} />
    </>
  );
};

export default Configuration;
